import React from "react";
import PropTypes from "prop-types";
import { Auth } from 'aws-amplify';
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import InputAdornment from "material-ui/Input/InputAdornment";
import Checkbox from "material-ui/Checkbox";
import FormControlLabel from "material-ui/Form/FormControlLabel";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import RegularCard from "components/Cards/RegularCard.jsx";
import Button from "components/CustomButtons/Button.jsx";
import IconButton from "components/CustomButtons/IconButton.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import UserNotifications from "components/UserNotifications/UserNotifications.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

class RegisterPage extends React.Component {

  errorDefault = [];

  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      notifications: this.errorDefault,
      supportSocial: false,
      username:"", password:"", email:"", phone_number:""
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.fieldHasError = this.fieldHasError.bind(this);


  }
  handleSubmit(event){

    const { username, password, email, phone_number} = this.state;

    Auth.signUp({
            username,
            password,
            attributes: {
                email,
                phone_number,
            },
            validationData: []  //optional
        })
        .then(data => {

          this.setState({error: [ ...this.errorDefault ]});

          this.props.history.push({pathname:"/account-verification", state:this.state});

        })
        .catch(error => {

          let errorUpdates = [];

          if( !error.message && error.toLowerCase().includes("username")){
            errorUpdates.push({type:"username", state: true, message: error});
          }

          if( !error.message && error.toLowerCase().includes("password")){
            errorUpdates.push({type:"password", state: true, message: error});
          }


          if(error.message && error.message.toLowerCase().includes("user")){
            errorUpdates.push({type:"username", state: true, message: error.message});
          }

          if(error.message && error.message.toLowerCase().includes("password")){
            errorUpdates.push({type:"password", state: true, message: error.message});
          }

          if(error.message && error.message.toLowerCase().includes("email")){
            errorUpdates.push({type:"email", state: true, message: error.message});
          }

          if(error.message && error.message.toLowerCase().includes("phone")){
            errorUpdates.push({type:"phone_number", state: true, message: error.message+" Should be in the format +16132223333"});
          }

          this.setState({notifications: [ ...this.errorDefault, ...errorUpdates ]});

          this.setState({notification: true});


        });  


  }
  fieldHasError(field){
    let result = false;
    this.state.notifications.map((prop,key)=>{
      if(prop.type===field&&prop.state){
        result = true;
      } 
      return false;
    });
    return result;
  }
  handleInput(e){
    this.setState({ [e.target.name]: e.target.value });
  
  }
  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  }


  render() {
    const { classes, translate } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <UserNotifications 
            notification={this.state.notification} 
            notifications={this.state.notifications} 
            onClose={() => this.setState({ notification: false })} 
          />
          <ItemGrid xs={12} sm={12} md={10}>
            <RegularCard
              cardTitle="Register"
              titleAlign="center"
              customCardTitleClasses={classes.cardTitle}
              customCardClasses={classes.cardClasses}
              content={
                <GridContainer justify="center">
                  <ItemGrid xs={12} sm={12} md={5}>
                    <InfoArea
                      title={translate("layout.registration.heading1")}
                      description={translate("layout.registration.text1")}
                      icon={Timeline}
                      iconColor="rose"
                    />
                    <InfoArea
                      title={translate("layout.registration.heading2")}
                      description={translate("layout.registration.text2")}
                      icon={Code}
                      iconColor="primary"
                    />
                    <InfoArea
                      title={translate("layout.registration.heading3")}
                      description={translate("layout.registration.text3")}
                      icon={Group}
                      iconColor="info"
                    />
                  </ItemGrid>
                  <ItemGrid xs={12} sm={8} md={5}>
                    {this.state.supportSocial?(
                    <div className={classes.center}>
                      <IconButton color="twitter">
                        <i className="fab fa-twitter" />
                      </IconButton>
                      {` `}
                      <IconButton color="google">
                        <i className="fab fa-google" />
                      </IconButton>
                      {` `}
                      <IconButton color="facebook">
                        <i className="fab fa-facebook-f" />
                      </IconButton>
                      {` `}
                      <h4 className={classes.socialTitle}>or be classical</h4>
                    </div>
                    ):""}
                    <form className={classes.form}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Face className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          placeholder: "Username...",
                          onChange: this.handleInput,
                          name: "username",                          
                        }}
                        error={this.fieldHasError("username")}                        
                      />
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          placeholder: "Email...",
                          onChange: this.handleInput,
                          name: "email",                          
                        }}
                        error={this.fieldHasError("email")}                        
                      />
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          placeholder: "Phone number...",
                          onChange: this.handleInput,
                          name: "phone_number",
                        }}
                        error={this.fieldHasError("phone_number")}                        
                      />
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <LockOutline
                                className={classes.inputAdornmentIcon}
                              />
                            </InputAdornment>
                          ),
                          placeholder: "Password...",
                          onChange: this.handleInput,
                          name: "password",
                        }}
                        error={this.fieldHasError("password")}                        

                      />
                      <FormControlLabel
                        classes={{
                          root: classes.checkboxLabelControl,
                          label: classes.checkboxLabel
                        }}
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggle(1)}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked
                            }}
                          />
                        }
                        label={
                          <span>
                            I agree to the{" "}
                            <a href="/terms-and-conditions">terms and conditions</a>.
                          </span>
                        }
                      />
                      <div className={classes.center}>
                        <Button onClick={(e) => this.handleSubmit(e)} round color="primary">
                          Get started
                        </Button>
                      </div>
                    </form>
                  </ItemGrid>
                </GridContainer>
              }
            />
          </ItemGrid>
        </GridContainer>
      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapDispatchToProps = {};

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
  }
}

export default compose(
  withStyles(registerPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(RegisterPage);



// WEBPACK FOOTER //
// ./src/views/User/RegisterPage.jsx